const FB_APP_ID = '4522668121312072';
const FB_API_VERSION = 'v22.0';

let loadPromise = null;

function loadFacebookSdk() {
  if (window.FB) {
    return Promise.resolve(window.FB);
  }
  if (loadPromise) {
    return loadPromise;
  }

  loadPromise = new Promise((resolve, reject) => {
    window.fbAsyncInit = function () {
      try {
        window.FB.init({
          appId: FB_APP_ID,
          cookie: false,
          xfbml: false,
          version: FB_API_VERSION
        });
        resolve(window.FB);
      } catch (err) {
        reject(err);
      }
    };

    const script = document.createElement('script');
    script.async = true;
    script.defer = true;
    script.src = 'https://connect.facebook.net/en_US/sdk.js';
    script.onerror = () => reject(new Error('Facebook SDK failed to load'));
    document.body.appendChild(script);
  });

  return loadPromise;
}

export function logFacebookPageView() {
  loadFacebookSdk()
    .then((FB) => {
      if (FB?.AppEvents?.logPageView) {
        FB.AppEvents.logPageView();
      }
    })
    .catch(() => {});
}

export function facebookLogin() {
  return loadFacebookSdk().then(
    (FB) =>
      new Promise((resolve, reject) => {
        FB.login(
          (response) => {
            if (response?.authResponse?.accessToken) {
              resolve(response.authResponse.accessToken);
              return;
            }
            if (response?.status === 'unknown' || !response?.authResponse) {
              resolve(null);
              return;
            }
            reject(new Error('Facebook sign-in failed'));
          },
          { scope: 'email,public_profile' }
        );
      })
  );
}

export { loadFacebookSdk, FB_APP_ID };
